/* eslint-disable */
/** CSS/markup copied from ヘルプ・問い合わせ_イージゲーム.html (header + article.faq). */
export const HELP_PAGE_CSS = `
.help-root h1, .help-root h2, .help-root h3, .help-root p, .help-root ul, .help-root li,
.help-root span, .help-root a, .help-root header, .help-root article, .help-root section, .help-root div {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
.help-root article, .help-root header, .help-root section {
  display: block;
}
.help-root ul {
  list-style: none;
}
.help-root {
  background: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  margin: 0;
  color: #3C3C3C;
  line-height: 1;
}
.help-root * {
  word-break: normal;
}
.help-root header {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  height: 50px;
  border-bottom: 1px solid #e9e9e9;
  position: relative;
}
.help-root .header__text {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  align-items: center;
}
.help-root .header__arrow {
  position: absolute;
  display: flex;
  align-items: center;
  padding-left: 25px;
  height: 100%;
  color: #3C3C3C;
  text-decoration: none;
  font-weight: bold;
  left: 0;
  top: 0;
  z-index: 1;
  font-size: 11px;
  font-family: 'Helvetica Neue', Helvetica, Arial, Roboto;
}
.help-root .header__arrow::before {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 13px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  content: '';
  width: 11px;
  height: 11px;
  margin: auto;
  border: 0 solid #535353;
  border-width: 2px 0 0 2px;
}
.help-root article a {
  color: #0574EB;
}
.help-root .faq {
  margin: 0 auto;
  padding: 0 20px 30px;
}
.help-root .faq__header, .help-root .contact__header {
  position: relative;
  margin: 0 auto;
  padding: 20px 0;
  width: 250px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.help-root .faq__header::after, .help-root .contact__header::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 250px;
  height: 2px;
  border-radius: 2px;
  background-color: #eb5505;
}
.help-root .faq__notes {
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.4;
}
.help-root .faq__content, .help-root .contact__content {
  margin-top: 25px;
}
.help-root .faq__crosshead, .help-root .contact__crosshead {
  padding-top: 15px;
  font-size: 16px;
  font-weight: bold;
}
.help-root .faq__list {
  margin-top: 17px;
}
.help-root .faq__item:first-child {
  border-top: 1px solid #b9b9b9;
}
.help-root .faq__item-question {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  position: relative;
  padding: 15px 20px 15px 10px;
}
.help-root .faq__item-question::before {
  display: inline-block;
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
  content: 'Q.';
}
.help-root .faq__item-answer {
  display: block;
  box-sizing: border-box;
  border-top: 1px solid #b9b9b9;
  border-bottom: 1px solid #b9b9b9;
  height: auto;
  padding: 10px;
  line-height: 1.5;
  background-color: #f6f6f6;
  overflow: hidden;
  opacity: 1;
  -webkit-transition: padding 0.3s, opacity 0.5s;
  transition: padding 0.3s, opacity 0.5s;
  padding-left: 30px;
  position: relative;
}
.help-root .faq__item-answer::before {
  display: inline-block;
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
  color: #ef3743;
  content: 'A.';
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1;
}
.help-root .faq__item-question::after {
  -webkit-transform: rotate(135deg) translate(2px,-2px) scale(-.7,-.7);
  transform: rotate(135deg) translate(2px,-2px) scale(-.7,-.7);
}
.help-root article a:visited {
  color: #5505eb !important;
}
.help-root .header__arrow:link,
.help-root .header__arrow:hover,
.help-root .header__arrow:active,
.help-root .header__arrow:visited {
  color: #3C3C3C;
  text-decoration: none;
}
.help-root article a:link,
.help-root article a:hover,
.help-root article a:active {
  color: #0574EB;
  text-decoration: underline;
}
.help-root article a:visited {
  text-decoration: underline;
}
`

export const HELP_INNER_HTML = `<header>
            <!-- 矢印 -->
            <a class="header__arrow" href="/">
                TOP
            </a>

            <h1 class="header__text">イージーゲーム　ヘルプ</h1>
        </header>
        <article class="faq">
            <h2 class="faq__header">よくある質問</h2>

            <p class="faq__notes">お問い合わせの前に、よくある質問をご確認ください。</p>

            <!-- 差分: 「auサービス全般について」「Pontaパスについて」セクションを削除 -->
            <section class="faq__content">
                <h3 class="faq__crosshead">イージーゲームについて</h3>
                <ul class="faq__list">
                    <li class="faq__item">
                        <!-- 差分: 新規Q&Aを追加 -->
                        <div class="faq__item-question">
                            ゲームが正常に遊べない
                        </div>
                        <div class="faq__item-answer">
                            <span>以下の推奨環境ではない環境では、正常に遊べない場合がございます。<br>また、注意事項記載の内容もご確認ください。</span><br><br>
                            <p>【推奨環境】</p>
                            <p>イージーゲーム</p>
                            <p>・Android 8 以上（Chrome 120以上）</p>
                            <p>・iOS 17.1 以上（Safari 17以上）</p><br>
                            <p>イージーゲーム powered by ゲソてん</p>
                            <p>・Android 最新版（Chrome 最新版）</p>
                            <p>・iOS 最新版（Safari 最新版）</p>
                            <p>※iOSではゲームの履歴が正常に表示されない場合があります。</p><br>
                            <p>【注意事項】</p>
                            <p>・不安定な通信環境では正常に遊べない場合があります。</p>
                            <p>・端末、OS、ブラウザのバージョンによっては正常に遊べない場合があります。</p>
                            <p>・プライベートブラウザモードでは正常に遊べない場合があります。</p>
                            <p>・広告ブロックを設定すると正常に遊べない場合があります。</p>
                            <p>・ブラウザのCookieやキャッシュをクリアすると、得点などの記録が消去されます。</p>
                            <p>・iOS 13.4以上の環境では7日以上の遊ばない期間が発生すると、得点などの記録が消去される場合があります。</p>
                            <p>・本サービスは日本国内専用です。</p>
                            <p>・This service is for Japan only.</p>
                        </div>
                        <!-- 差分: 回答文言を「推奨環境・注意事項」を直接参照する形に変更（旧: 外部リンク「イージーゲーム 推奨環境・注意事項」への誘導文言） -->
                        <div class="faq__item-question">
                            イージーゲームについて問い合わせたい
                        </div>
                        <div class="faq__item-answer">
                            <span>お問い合わせ前に上記の推奨環境・注意事項をご確認いただき、「<a href="mailto:easygames-support@mail.mediba.jp?subject=%E3%82%A4%E3%83%BC%E3%82%B8%E3%83%BC%E3%82%B2%E3%83%BC%E3%83%A0 %E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B&body=%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B%E3%81%AE%E5%86%85%E5%AE%B9%E3%82%92%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84%E3%80%82%0A%E3%82%B2%E3%83%BC%E3%83%A0%E5%90%8D%20or%20URL%EF%BC%9A%0A%E4%BA%8B%E8%B1%A1%EF%BC%9A%E3%80%90%E4%BE%8B%E3%80%91%E5%BA%83%E5%91%8A%E3%81%8C%E8%A1%A8%E7%A4%BA%E3%81%95%E3%82%8C%E3%81%9F%E5%BE%8C%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8C%E5%A7%8B%E3%81%BE%E3%82%89%E3%81%AA%E3%81%84%E7%AD%89%EF%BC%88%E5%8B%95%E7%94%BB%2F%E3%82%B9%E3%82%AF%E3%82%B7%E3%83%A7%E6%B7%BB%E4%BB%98%EF%BC%89%0A%E7%99%BA%E7%94%9F%E6%97%A5%E6%99%82%EF%BC%9A%0A%E7%AB%AF%E6%9C%AB%E3%81%AE%E6%A9%9F%E7%A8%AE%E5%90%8D%EF%BC%9A%0AOS%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%EF%BC%9A%0A%E5%88%A9%E7%94%A8%E3%83%96%E3%83%A9%E3%82%A6%E3%82%B6%E3%81%A8%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%EF%BC%9A%0A%0A%E2%96%BCOS%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E3%81%AE%E8%AA%BF%E3%81%B9%E6%96%B9%0A%E3%83%BBAndroid%E3%81%AE%E5%A0%B4%E5%90%88%0A%5B%E8%A8%AD%E5%AE%9A%5D%E2%86%92%5B%E7%AB%AF%E6%9C%AB%E6%83%85%E5%A0%B1%5D%0A%E3%83%BBiOS%E3%81%AE%E5%A0%B4%E5%90%88%0A%5B%E8%A8%AD%E5%AE%9A%5D%E2%86%92%5B%E4%B8%80%E8%88%AC%5D%E2%86%92%5B%E6%83%85%E5%A0%B1%5D%0A%0A%E2%96%BC%E3%83%96%E3%83%A9%E3%82%A6%E3%82%B6%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E3%81%AE%E8%AA%BF%E3%81%B9%E6%96%B9%0A%E3%83%BBAndroid%2FChrome%E3%81%AE%E5%A0%B4%E5%90%88%0A%5B%E8%A8%AD%E5%AE%9A%5D%E2%86%92%5B%E3%83%87%E3%83%90%E3%82%A4%E3%82%B9%E6%83%85%E5%A0%B1%5D%0A%E3%83%BBsafari%E3%81%AE%E5%A0%B4%E5%90%88%0AiOS%E3%83%90%E3%83%BC%E3%82%B8%E3%83%A7%E3%83%B3%E3%81%AE%E3%81%BF%E3%81%A7OK" class="js-analytics" data-ga-category="PortalTop_ヘルプ" data-ga-action="Q&A" data-ga-label="イージーゲーム お問い合わせ">イージーゲームお問い合わせ</a>」より、お問い合わせください。</span>
                        </div>
                    </li>
                </ul>
            </section>
            <!-- 差分: 「au Webポータルについて」セクションを削除 -->
        </article>`
